import { makeStyles } from '@material-ui/core/styles';
import { theme } from './theme';
import { descriptionText } from './sharedStyles';

export const useStyles = makeStyles(() => ({
  descricao: {
    ...descriptionText,
    margin: '0 0 25px 0',
  },
  exibicaoEmail: {
    fontWeight: 700,
    fontSize: theme.fontSizes.xs,
    lineHeight: '16px',
    marginBottom: '20px',
  },
}));